import { TYPE_POPOVER } from "../../components/shared/components/ChatBot/components/editor/constants";
import { generateUUID } from "../../services/helpers/Helper";
import { FAQ_TYPE } from "../constants";
const _ = require('lodash');

const faqReducer = (state = {
   faqs: {
      is_active: 0,
      items: []
   },
   faq: {
      blocks: []
   }
}, action) => {
   switch (action.type) {
      case FAQ_TYPE.FETCHS:
         return {
            ...state,
            faqs: {
               ...state.faqs,
               ...action.payload
            }
         };
      case FAQ_TYPE.FETCH:
         if (!_.get(action.payload, 'first_block')) {
            action.payload.first_block = {
               temporary_block_id: generateUUID(),
               title: "Nội dung mở đầu",
               type: TYPE_POPOVER.ICEBREAKER,
               cards: [
                  {
                     temporary_block_id: generateUUID(),
                     type: "text",
                     title: "👋 Vui lòng cho chúng tôi biết bạn cần hỗ trợ gì nhé!",
                     buttons: [
                     ]
                  },
               ],
               is_hidden: 0,
               is_first_block: 1,
            }
         }

         if (!_.get(action.payload, 'blocks')) {
            action.payload.blocks = []
         }
         return {
            ...state,
            faq: action.payload
         }
      case FAQ_TYPE.ADD:
         if (state.faqs.items.find(f => !f.is_actived)) {
            return state;
         }
         return {
            ...state,
            faqs: {
               ...state.faqs,
               items: [...state.faqs.items, action.payload]
            }
         };
      case FAQ_TYPE.DELETE:
         return {
            ...state,
            faqs: {
               ...state.faqs,
               items: state.faqs.items.filter(item => item.id !== action.payload)
            }
         };
      case FAQ_TYPE.UPDATE_ACTIVE:
         return {
            ...state,
            faqs: {
               ...state.faqs,
               is_active: action.payload
            }
         };
      case FAQ_TYPE.DELETE_NOT_ACTIVE:
         return {
            ...state,
            faqs: {
               ...state.faqs,
               items: state.faqs.items.filter(item => item.is_actived)
            }
         };
      case FAQ_TYPE.ON_CHANGE:
         return {
            ...state,
            faq: {
               ...state.faq,
               ...action.payload
            }
         };
      case FAQ_TYPE.UPDATE_NAME:
         return {
            ...state,
            faqs: {
               ...state.faqs,
               items: state.faqs.items.map(item => item.id === action.payload.id ? action.payload : item)
            }
         };
      default:
         return state;
   }
};

export default faqReducer